import { makeActionCreator } from '../../config/store/utils'
import { batch } from 'react-redux'
import {
  disablePurchaseOrderAlerts,
  getPurchaseOrderStatus,
  setStatusPurchaseOrder
} from '../../services/purchaseOrder'
import { format } from 'date-fns'

export const GET_PURCHASE_ORDER_STATUS = 'GET_PURCHASE_ORDER_STATUS'
export const GET_PURCHASE_ORDER_STATUS_ERROR = 'GET_PURCHASE_ORDER_STATUS_ERROR'
export const GET_PURCHASE_ORDER_STATUS_SUCCESS = 'GET_PURCHASE_ORDER_STATUS_SUCCESS'
export const onGetPurchaseOrderStatus = makeActionCreator(GET_PURCHASE_ORDER_STATUS)
export const onGetPurchaseOrderStatusError = makeActionCreator(GET_PURCHASE_ORDER_STATUS_ERROR, 'payload')
export const onGetPurchaseOrderStatusSuccess = makeActionCreator(GET_PURCHASE_ORDER_STATUS_SUCCESS, 'payload')
export const onGetPurchaseOrderStatusThunk =
  ({ purchaseOrderId, requestQuoteId }) =>
  async dispatch => {
    dispatch(onGetPurchaseOrderStatus())
    try {
      const { data } = await getPurchaseOrderStatus({ purchaseOrderId, requestQuoteId })

      const basicInfo = {
        purchaseOrderId: data.payload.tittle.ordenCompraID,
        quoteId: data.payload.tittle.solicitudID,
        shippingDate: format(new Date(data.payload.tittle.fechaEnvio), "dd-MM-yyyy 'a las' HH:mm:ss"),
        state: data.payload.tittle.estado,
        textState: data.payload.tittle.estadoFront,
        name: data.payload.head.nombre,
        description: data.payload.head.descripcion,
        address: data.payload.head.direccion,
        organism: data.payload.head.organismo,
        publicationDate: format(new Date(data.payload.head.fechaPublicacion), "dd-MM-yyyy 'a las' HH:mm:ss"),
        deadline: format(new Date(data.payload.head.fechaCierre), "dd-MM-yyyy 'a las' HH:mm:ss"),
        deliveryTerm: `${data.payload.head.plazoEntrega} días`,
        netAmount: data.payload.body.montoNeto,
        tax: data.payload.body.montoImpuesto,
        totalAmount: data.payload.body.montoTotal,
        nameTax: data.payload.body.impuesto,
        productsDescription: data.payload.body.descripcion
      }

      const products = data.payload.body.productos.map(product => ({
        quoteProductId: product.solicitudCotizacionProductoId,
        productId: product.codigoProducto,
        quantity: product.cantidad,
        unitPrice: product.precioUnitario,
        amount: product.montoTotal,
        unit: product.unidad,
        description: product.descripcion,
        name: product.nombre
      }))

      const swornDeclaration = {
        shippingDate: format(new Date(data.payload.declaracion.fechaEnvio), "dd-MM-yyyy 'a las' HH:mm:ss"),
        fullName: data.payload.declaracion.nombreCompleto,
        bussineName: data.payload.declaracion.razonSocial,
        dni: data.payload.declaracion.rut,
        DJAditionalDetail: data.payload.detalleAdicionalDJ,
        DJBeneficiaries: data.payload.beneficiariosFinales,
        DJIdRespuesta: data.payload.idRespuesta
      }

      return dispatch(onGetPurchaseOrderStatusSuccess({ basicInfo, products, swornDeclaration }))
    } catch (error) {
      return dispatch(onGetPurchaseOrderStatusError({ error }))
    }
  }

export const CHANGE_STATUS_PURCHASE_ORDER = 'CHANGE_STATUS_PURCHASE_ORDER'
export const CHANGE_STATUS_PURCHASE_ORDER_ERROR = 'CHANGE_STATUS_PURCHASE_ORDER_ERROR'
export const CHANGE_STATUS_PURCHASE_ORDER_SUCCESS = 'CHANGE_STATUS_PURCHASE_ORDER_SUCCESS'
export const onChangeStatusPurchaseOrder = makeActionCreator(CHANGE_STATUS_PURCHASE_ORDER)
export const onChangeStatusPurchaseOrderError = makeActionCreator(CHANGE_STATUS_PURCHASE_ORDER_ERROR, 'payload')
export const onChangeStatusPurchaseOrderSuccess = makeActionCreator(CHANGE_STATUS_PURCHASE_ORDER_SUCCESS, 'payload')
export const onChangeStatusPurchaseOrderThunk = payload => async dispatch => {
  dispatch(onChangeStatusPurchaseOrder())
  try {
    const { data } = await setStatusPurchaseOrder({ quoteId: payload.quoteId })

    return batch(() => {
      dispatch(onChangeStatusPurchaseOrderSuccess({ success: data?.success }))
      payload.callback()
    })
  } catch (error) {
    const errors = error?.originalError?.response?.data?.errores.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))

    return dispatch(onChangeStatusPurchaseOrderError({ errors }))
  }
}

export const SAVE_PURCHASE_ORDER_CODE = 'SAVE_PURCHARSE_ORDER_CODE'
export const onSavePurchaseOrderCode = makeActionCreator(SAVE_PURCHASE_ORDER_CODE, 'payload')

export const DISABLE_PURCHASE_ORDER_ALERTS = 'DISABLE_PURCHASE_ORDER_ALERTS'
export const DISABLE_PURCHASE_ORDER_ALERTS_ERROR = 'DISABLE_PURCHASE_ORDER_ALERTS_ERROR'
export const DISABLE_PURCHASE_ORDER_ALERTS_SUCCESS = 'DISABLE_PURCHASE_ORDER_ALERTS_SUCCESS'
export const onDisablePurchaseOrderAlerts = makeActionCreator(DISABLE_PURCHASE_ORDER_ALERTS)
export const onDisablePurchaseOrderAlertsError = makeActionCreator(DISABLE_PURCHASE_ORDER_ALERTS_ERROR, 'payload')
export const onDisablePurchaseOrderAlertsSuccess = makeActionCreator(DISABLE_PURCHASE_ORDER_ALERTS_SUCCESS, 'payload')
export const onDisablePurchaseOrderAlertsThunk = payload => async dispatch => {
  dispatch(onDisablePurchaseOrderAlerts())

  try {
    const { data } = await disablePurchaseOrderAlerts({ quoteId: payload.quoteId })

    return batch(() => {
      dispatch(onDisablePurchaseOrderAlertsSuccess({ success: data?.success }))
      payload.callback()
    })
  } catch (error) {
    const errors = error?.originalError?.response?.data?.errores.map(error => ({
      code: error.codigo,
      description: error.descripcion
    }))
    return dispatch(onDisablePurchaseOrderAlertsError({ errors }))
  }
}

export const CLEAN_ERRORS_PURCHASE_ORDER_STATUS = 'CLEAN_ERRORS_PURCHASE_ORDER_STATUS'
export const onCleanErrorsPurchaseOrderStatus = makeActionCreator(CLEAN_ERRORS_PURCHASE_ORDER_STATUS, 'payload')
